import { toast } from "react-toastify";

export function simulateLinkClickNewTab(url: string, newTab = true) {
  const link = document.createElement("a");

  document.body.appendChild(link);
  link.href = url;
  if (newTab) {
    link.target = "_blank";
  }
  link.click();
  document.body.removeChild(link);
}

export function scrollToTop() {
  window.scrollTo(0, 0);
}

export default {
  simulateLinkClickNewTab,
  scrollToTop,
};

export function scrollIntoView(node: Element | null | undefined) {
  if (node) {
    node.scrollIntoView();
  }
}

export function downloadCSVFromString(csvString: string, fileName: string) {
  // Convert the CSV string to a Blob
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });

  // Create a link element
  const link = document.createElement("a");

  // Set the link's href attribute to a URL representing the Blob
  link.href = URL.createObjectURL(blob);

  // Set the download attribute with the desired file name
  link.download = fileName;

  // Append the link to the document
  document.body.appendChild(link);

  // Trigger a click on the link to start the download
  link.click();

  // Remove the link from the document
  document.body.removeChild(link);
}

export function copyTextToClipboard(text: string, label = "URL") {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success(`${label} copied to clipboard!`);
    })
    .catch((err) => {
      // NOTE: err is passed where toast *options* belong (pre-existing latent
      // bug, behavior preserved; flagged for a follow-up fix)
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      toast.error(`Failed to copy the ${label}: `, err);
    });
}
